import { globalActions } from '../../global-actions';

export const getActionTypes = (actionPrefix) => ({
  QUERY_START: `${actionPrefix}_QUERY_START`,
  QUERY_SUCCESS: `${actionPrefix}_QUERY_SUCCESS`,
  QUERY_FAILURE_GENERIC: `${actionPrefix}_QUERY_FAILURE_GENERIC`,
  QUERY_FAILURE_401: `${actionPrefix}_QUERY_FAILURE_401`,
  SHOW_BANNER_BOTTOM: `${actionPrefix}_SHOW_BANNER_BOTTOM`,
  HIDE_BANNER_BOTTOM: `${actionPrefix}_HIDE_BANNER_BOTTOM`,
});

export const getActions = (actionPrefix) => ({
  setQueryStart: () => {
    globalActions.next({
      type: getActionTypes(actionPrefix).QUERY_START,
    });
  },
  setQuerySuccess: (data) => {
    globalActions.next({
      type: getActionTypes(actionPrefix).QUERY_SUCCESS,
      payload: { data },
    });
  },
  setQueryFailureGeneric: (error) => {
    globalActions.next({
      type: getActionTypes(actionPrefix).QUERY_FAILURE_GENERIC,
      payload: { error },
    });
  },
  setQueryFailure401: (error) => {
    globalActions.next({
      type: getActionTypes(actionPrefix).QUERY_FAILURE_401,
      payload: { error },
    });
  },
  showBannerBottom: () => {
    globalActions.next({
      type: getActionTypes(actionPrefix).SHOW_BANNER_BOTTOM,
    });
  },
  hideBannerBottom: () => {
    globalActions.next({
      type: getActionTypes(actionPrefix).HIDE_BANNER_BOTTOM,
    });
  },
});
